module.exports = __webpack_public_path__ + "static/yinka-876d106bacf6654a2e48364e8d45e7fd.jpg";